function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import SpzaComponent from './spzaComponent';
// eslint-disable-next-line import/named
import { Text } from '@fluentui/react';
import * as React from 'react';
import { Tab, Tabs } from './tabs';
export class StickyCard extends SpzaComponent {
    static handleScroll(curWindow, appearUnderElementId) {
        const elementToAppearAfter = document.getElementById(appearUnderElementId);
        if (curWindow && elementToAppearAfter && elementToAppearAfter.offsetTop) {
            const tabsYOffset = elementToAppearAfter.offsetTop + 43;
            if (curWindow.pageYOffset > tabsYOffset) {
                return true;
            }
            return false;
        }
    }
    renderImpl() {
        const titleStyles = {
            root: {
                marginLeft: 8,
                fontWeight: 600,
                lineHeight: 20
            }
        };
        return /*#__PURE__*/ _jsx("div", {
            className: "stickyCard",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "stickyCardContainer",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "stickyCardSubContainer",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "stickyCardLeft",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "stickCardPublisher",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "stickyCardIcon",
                                            children: /*#__PURE__*/ _jsx("div", {
                                                children: /*#__PURE__*/ _jsx("img", {
                                                    className: "StickyIconImg",
                                                    src: this.props.logoURL,
                                                    alt: this.props.title + ' icon',
                                                    onError: (e)=>e && e.target && e.target.style ? e.target.style.display = 'none' : null
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            variant: "medium",
                                            block: true,
                                            nowrap: true,
                                            styles: titleStyles,
                                            children: this.props.title
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "stickyCardTabs",
                                    children: /*#__PURE__*/ _jsx(Tabs, {
                                        defaultTab: this.props.tabsProps.defaultTab,
                                        ownerType: this.props.tabsProps.ownerType,
                                        ownerId: this.props.tabsProps.ownerId,
                                        changeTabCallback: this.props.tabsProps.changeTabCallback,
                                        getTabHref: this.props.tabsProps.getTabHref,
                                        children: this.props.tabsChilds.map((tabChild, index)=>/*#__PURE__*/ _jsx(Tab, {
                                                title: tabChild.title,
                                                name: tabChild.name,
                                                textBadge: tabChild.textBadge,
                                                children: /*#__PURE__*/ _jsx("div", {})
                                            }, index))
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "stickyCardRight",
                            children: /*#__PURE__*/ _jsx("div", {
                                className: "stickyCardSubContainer",
                                children: this.props.children
                            })
                        })
                    })
                ]
            })
        });
    }
    constructor(...args){
        super(...args), _define_property(this, "context", void 0);
    }
}
